import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import axiosInstance from '../axiosInterceptor'
import { toast } from 'react-toastify'
import CommonEditor from './CommonEditor'

const AddTestimonial = () => {
    const navigator = useNavigate();
    const location = useLocation();
    const editData = location.state;
    const [data, setData] = useState({
        position: editData?.position || '',
        name: editData?.name || '',
        address: editData?.address || '',
        description: editData?.description || '',
        // rating: editData?.rating || '',
        isActive: editData?.isActive || false,
    });
    const [errors, setErrors] = useState({
        position: '',
        name: '',
        address: '',
        description: '',
        // rating: '',
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setData({ ...data, [name]: type === 'checkbox' ? checked : value });
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { position, name, address, description } = data;

        const trimString = (value) => typeof value === 'string' ? value.trim() : value;

        if (!trimString(position) || !trimString(name) || !trimString(address) || !trimString(description)) {
            // || !trimString(rating)
            setErrors({
                position: !trimString(position) ? 'Position is required' : '',
                name: !trimString(name) ? 'Project name is required' : '',
                address: !trimString(address) ? 'Name is required' : '',
                description: !trimString(description) ? 'Description is required' : '',
                //rating: !trimString(rating) ? 'Rating is required' : '',
            });
            return;
        }

        try {
            const response = await axiosInstance.post('testimonial/createTestimonial', data);
            if (response.status === 200) {
                toast.success(response.data.message);
                navigator('/testimonial');
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        const { position, name, address, description } = data;

        const trimString = (value) => typeof value === 'string' ? value.trim() : value;

        if (!trimString(position) || !trimString(name) || !trimString(address) || !trimString(description)) {
            //|| !trimString(rating)
            setErrors({
                position: !trimString(position) ? 'Position is required' : '',
                name: !trimString(name) ? 'Project name is required' : '',
                address: !trimString(address) ? 'Name is required' : '',
                description: !trimString(description) ? 'Description is required' : '',
                // rating: !trimString(rating) ? 'Rating is required' : '',
            });
            return;
        }

        try {
            const response = await axiosInstance.put(`testimonial/updateTestimonial/${editData?._id}`, data);
            if (response.status === 200) {
                toast.success(response.data.message);
                navigator('/testimonial');
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };

    return (
        <>
            <div className="content-wrapper">
                <div className="page-header mx-4 mt-5">
                    <h3 className="page-title">Add Testimonial </h3>
                </div>
                <div className="col-md-12 grid-margin stretch-card">
                    <div className="col-md-8">
                        <div className="card">
                            <div className="card-body">
                                <form className="pt-3" onSubmit={editData?._id ? handleUpdate : handleSubmit}>
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Position
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="number"
                                                className="form-control form-control-sm"
                                                id="position"
                                                name="position"
                                                placeholder="Enter position"
                                                value={data.position}
                                                onChange={handleChange}
                                            />
                                            {errors.position && <p className="text-danger">{errors.position}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Project Name
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="name"
                                                name="name"
                                                placeholder="Enter project name"
                                                value={data.name}
                                                onChange={handleChange}
                                            />
                                            {errors.name && <p className="text-danger">{errors.name}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Description
                                        </label>
                                        <div className="col-sm-9">
                                            <CommonEditor
                                                value={data.description}
                                                placeholder='Enter content ...'
                                                onChange={(value) => handleChange({ target: { name: 'description', value } })}
                                            />
                                            {errors.description && !data?.description?.trim() && (
                                                <div className="text-danger">Description is required</div>
                                            )}
                                            {/* <textarea
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="description"
                                                name="description"
                                                placeholder="Enter description"
                                                value={data.description}
                                                onChange={handleChange}
                                                style={{ height: '150px' }}
                                            />
                                            {errors.description && <p className="text-danger">{errors.description}</p>} */}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Name
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="address"
                                                name="address"
                                                placeholder="Enter name"
                                                value={data.address}
                                                onChange={handleChange}
                                            />
                                            {errors.address && <p className="text-danger">{errors.address}</p>}
                                        </div>
                                    </div>

                                    {/* <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Rating
                                        </label>

                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="rating"
                                                name="rating"
                                                placeholder="Enter rating"
                                                value={data.rating}
                                                onChange={handleChange}
                                            />
                                            {errors.rating && <p className="text-danger">{errors.rating}</p>}
                                        </div>
                                    </div> */}

                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 "
                                        >Is Active
                                        </label>
                                        <div className="col-sm-9">
                                            <div className="custom-control custom-switch">
                                                <input
                                                    type="checkbox" className="custom-control-input"
                                                    name='isActive'
                                                    id="isActiveSwitch"
                                                    checked={data.isActive}
                                                    onChange={(e) => handleChange(e)} />
                                                <label className="custom-control-label " for="isActiveSwitch">{data.isActive === true ? "Active" : "Deactive"}</label>

                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-3 col-form-label"></label>
                                                <div className="col-sm-9">

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='text-center'>
                                        <Link to="/testimonial"><button className="btn btn-secondary mr-2">
                                            Back </button></Link>
                                        <button type="submit" className="btn btn-success">
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddTestimonial;